(ns teamoesterreich.admin-mode.user.user-card-help-neighbor
  (:require [clojure.string]
            [reagent.core :as r]
            [reagent-material-ui.components :as mui]
            [teamoesterreich.util.log :as log]
            [teamoesterreich.util.date :as h-date]
            [teamoesterreich.admin-mode.data.user :as d-user]
            [teamoesterreich.admin-mode.data.rights :as d-rights]
            [teamoesterreich.ajax :as ajax]
            [teamoesterreich.admin-mode.data.backend :as backend]

            ))



(defn >user-edit-field [user-uuid obj cb-fn]
  (ajax/patch> (str backend/BASE_URL "/user/" user-uuid)
               (ajax/serialize (merge {:user-uuid user-uuid}
                                      obj))
               cb-fn))




(defn check-box [text !actual-user !st key allowEdit?]
  (let [!edited (r/cursor !st [key])
        checked (get @!actual-user key)
        val (if (nil? @!edited) checked @!edited)
        changed? (and (not (nil? @!edited)) (not= @!edited checked))]
    [mui/grid
     {:container false
      :item      true
      :md        6                                          ;medium: 960px
      :xs        12                                         ;extra-small: 0px
      :style     {:backgroundColor (if changed? "#ffd6d2" "#ffffff")}
      }
     [mui/form-control-label {:style     {:backgroundColor (if changed? "#ffd6d2" "#ffffff")}
                              :label     (str text)
                              :disabled  (if allowEdit? false true)
                              :checked   (if val true false)
                              :onChange  (fn [_ b]
                                           (log/debug "edit " text " " (:user-tomId @!actual-user) "->" (not b))
                                           (reset! !edited b))
                              :placement "start"
                              :control   (r/as-element [mui/checkbox {}])}]

     ]))


(defn checkbox-form [!actual-user]
  (let [!st (r/atom {})]
    (fn []
      (let [allowEdit? (d-rights/allow-admin-for d-rights/USER_EDIT (:user-orgId @!actual-user))
            changed? (reduce (fn [c [k v]] (or c (not= v (get @!actual-user k)))) false @!st)
            ]

        [mui/grid
         {:container  true
          :direction  "row"
          :justify    "space-between"
          :alignItems "flex-start"
          :spacing    4
          }

         [mui/grid
          {:container false
           :item      true
           :md        12                                    ;medium: 960px
           :xs        12                                    ;extra-small: 0px
           }
          [mui/typography {:variant "h6"} "Voraussetzungen"]
          [mui/typography {} "hier kommt einen Erklärung für den Admin rein "]
          ]

         [mui/grid
          {:container false
           :item      true
           :md        12                                    ;medium: 960px
           :xs        12                                    ;extra-small: 0px
           }
          [mui/typography {:variant "h6"} "Einstellungen"]
          [mui/typography {} "Folgende Einstellungen zur Nachbarschaftshilfe wurden gesetzt:"]
          ]

         [mui/grid
          {:container false
           :item      true
           :md        6                                    ;medium: 960px
           :xs        12                                    ;extra-small: 0px
           }
          [check-box (str "Ohne Katastrophe bin ich bereit zur Nachbarschaftshilfe.")
           !actual-user
           !st
           :user-helpingNormNachbarschaftshilfe
           allowEdit?]
          ]

         [mui/grid
          {:container false
           :item      true
           :md        6                                    ;medium: 960px
           :xs        12                                    ;extra-small: 0px
           }
          [check-box (str "Bei einer Katastrophe bin ich bereit zur Nachbarschaftshilfe.")
           !actual-user
           !st
           :user-helpingKatNachbarschaftshilfe
           allowEdit?]
          ]

         [mui/grid
          {:container false
           :item      true
           :md        12                                    ;medium: 960px
           :xs        12                                    ;extra-small: 0px
           }

          (when changed?
            [mui/card-actions

             [mui/button {
                          :color   "secondary"
                          :variant "contained"
                          :onClick #(reset! !st nil)
                          } "Abbrechen"]
             [mui/button {
                          :color   "primary"
                          :variant "contained"
                          :onClick (fn []
                                     (d-user/>user-edit-field (:user-uuid @!actual-user)
                                                              @!st
                                                              (fn []
                                                                (reset! !st {})
                                                                (d-user/actual-user-invalidate !actual-user)
                                                                )))
                          } "Speichern"]
             ])

          ]
         ]
        ))))



(defn action-required-form [!actual-user]
  (let [!state (r/atom {})]
    (fn []
      (let [warning-key :user-wanado-warnings-neighbor-text
            level-key :user-wanado-warnings-neighbor-level
            warn-text (or (warning-key @!state) (get @!actual-user warning-key) "")
            warn-level (or (level-key @!state) (get @!actual-user level-key) 0)
            changed-warn-text? (not= (or (get @!actual-user warning-key) "") warn-text)
            changed-warn-level? (not= (or (get @!actual-user level-key) 0) warn-level)
            changed? (or changed-warn-text? changed-warn-level?)
            ]
        [mui/grid
         {:container false
          :item      true
          :md        12                                     ;medium: 960px
          :xs        12                                     ;extra-small: 0px
          }
         [:form
          {:onSubmit (fn [e] (.preventDefault e))}
          [mui/grid
           {:container  true
            :direction  "row"
            :justify    "space-between"
            :alignItems "flex-start"
            :spacing    0
            }
           [mui/grid
            {:container false
             :item      true
             :md        4                                   ;medium: 960px
             :xs        12                                  ;extra-small: 0px
             }
            [mui/form-control {:component "fieldset"}
             [mui/radio-group {:row   true
                               :style {:backgroundColor (if changed-warn-level? "#ffd6d2" "#ffffff")}
                               :value (str warn-level)
                               }
              [mui/form-control-label
               {:value    "0"
                :disabled true
                :control  (r/as-element [mui/radio {:color "primary"}])
                :label    (str "Kein")
                }
               ]
              [mui/form-control-label
               {:value    "1"
                :disabled true
                :control  (r/as-element [mui/radio {:color "primary"}])
                :label    (str "Info")
                }
               ]
              [mui/form-control-label
               {:value    "2"
                :disabled true
                :control  (r/as-element [mui/radio {:color "primary"}])
                :label    (str "Warn")
                }
               ]]
             ]
            ]
           [mui/grid
            {:container false
             :item      true
             :md        6                                   ;medium: 960px
             :xs        12                                  ;extra-small: 0px
             }
            (when (not= warn-level 0)
              [mui/text-field {
                               :style        {:backgroundColor (if changed-warn-text? "#ffd6d2" "#ffffff")}
                               :fullWidth    true
                               :disabled     true
                               :defaultValue warn-text
                               }])

            ]

           [mui/grid
            {:container false
             :item      true
             :md        2                                   ;medium: 960px
             :xs        12                                  ;extra-small: 0px

             }
            (when changed?
              [mui/button
               {:style   {:float         "right"
                          :verticalAlign "middle"
                          :margin-right  "30px"
                          }
                :color   "primary"
                :variant "outlined"
                :onClick (fn []
                           (>user-edit-field (:user-uuid @!actual-user)
                                             {warning-key (if (= warn-level 0) "" warn-text)
                                              level-key   warn-level}
                                             (fn [] (d-user/actual-user-invalidate !actual-user))))}
               "Speichern"]
              )
            ]
           ]
          ]]

        ))))


(defn get-it [!actual-user]
  (let [])
  [mui/card {:style {:textAlign "left"}}
   [mui/card-header
    {:title (r/as-element [:span "Nachbarschaftshilfe "
                           [mui/checkbox {:checked  (or (get @!actual-user :user-helpingNeighbor) false)
                                          :color    "primary"
                                          :disabled true
                                          }]])}]
   [mui/card-content
    {
     :style {:padding "20px"}
     }


    [mui/grid
     {:container  true
      :direction  "row"
      :justify    "space-between"
      :alignItems "flex-start"
      :spacing    4
      }

     (when (:user-helpingNeighborSince @!actual-user)
       [mui/grid
        {:container false
         :item      true
         :md        12                                      ;medium: 960px
         :xs        12                                      ;extra-small: 0px
         }
        [mui/grid
         {:container  true
          :direction  "row"
          :justify    "space-between"
          :alignItems "flex-start"
          :spacing    0
          }
         [mui/grid
          {:container false :item true
           :md        4
           :xs        12
           } [mui/typography {} "Seit "]]
         [mui/grid
          {:container false :item true
           :md        8
           :xs        12
           } [mui/text-field {:fullWidth    true :style {:maxWidth "300px"}
                              :disabled     true
                              :defaultValue (h-date/print-local-date (:user-helpingNeighborSince @!actual-user))}]]
         ]]
       )

     [mui/grid
      {:container false
       :item      true
       :md        12                                        ;medium: 960px
       :xs        12                                        ;extra-small: 0px
       }
      [mui/typography {:variant "h6"} "Aktionen / Hinweise"]]

     [(action-required-form !actual-user)]
     ]
    [(checkbox-form !actual-user)]

    ]
   ])